import { customAxios, IDUSUARIO, FDV_URL } from '../constants';
// <90249> ivelasquez 12/03/2021
export default function(fdvID) {

    const config = {
        headers: {
            codUsuario : IDUSUARIO
        }
    };

    return customAxios.get(`${FDV_URL}/archivoAdjunto/listarPlacas/${fdvID}`,config);
}


// WEBPACK FOOTER //
// ./src/utils/getPlacas.js